<button (click)="checkout()">Pay with Stripe</button>
<button (click)="directRedirection()">Direct Redirection</button>
